import { AccountTab } from "./account-tab";
import { CareTab } from "./care/care-tab";
import { FirstMomentsRecordRows } from "./first-moments-record-rows";
import { MentorshipsTab } from "./mentorships-tab";
import { PerformanceTab } from "./performance-tab";
import { RecordMatchingProfileTab } from "./record-matching-profile-tab";
import { SupervisionTab } from "./supervision-tab";
import { RolesTab } from "@/components/users/user-details/roles-tab";
import { UserMentorSchedule } from "@/components/users/user-details/user-mentor-schedule";
import type { User } from "@/lib/api/user";
import { getPreferredName } from "@/lib/redacted-display";
import type { UserRecordTabId } from "./user-record-tabs";

interface UserRecordTabContentProps {
  tabId: UserRecordTabId;
  user: User;
  canReadMentorships: boolean;
}

export function UserRecordTabContent({
  tabId,
  user,
  canReadMentorships,
}: UserRecordTabContentProps) {
  switch (tabId) {
    case "account":
      return <AccountTab user={user} surface="record" />;
    case "mentorships":
      return (
        <MentorshipsTab user={user} canReadMentorships={canReadMentorships} />
      );
    case "performance":
      return (
        <PerformanceTab mentorId={user.id} />
      );
    case "matching":
      return <RecordMatchingProfileTab user={user} />;
    case "first-moments":
      return (
        <FirstMomentsRecordRows
          userId={user.id}
          mentorName={getPreferredName(user) || "this mentor"}
        />
      );
    case "schedule":
      return <UserMentorSchedule user={user} />;
    case "supervision":
      return <SupervisionTab userId={user.id} />;
    case "care":
      return <CareTab menteeId={user.id} />;
    case "roles":
      return (
        <div className="rounded-[20px] border border-[#dfddd8] bg-white p-6">
          <RolesTab userId={user.id} />
        </div>
      );
    default: {
      const _exhaustive: never = tabId;
      return _exhaustive;
    }
  }
}
